export const myAccountPages = [
	{
		path: 'personal',
		icon: 'user',
		text: 'MY_ACCOUNT_MENU.PERSONAL',
	},
	{
		path: 'professional',
		icon: 'star',
		text: 'MY_ACCOUNT_MENU.PROFESSIONAL',
	},
	{
		path: 'definitions',
		icon: 'edit',
		text: 'MY_ACCOUNT_MENU.PLANS_SESSIONS',
	},
	{
		path: 'online-sessions',
		icon: 'video',
		text: 'MY_ACCOUNT_MENU.SESSIONS_ONLINE',
		sub: true,
	},
	{
		path: 'onsite-sessions',
		icon: 'building-community',
		text: 'MY_ACCOUNT_MENU.SESSIONS_ONSITE',
		sub: true,
		onlyPremium: true,
	},
	{
		path: 'payment',
		icon: 'report-money',
		text: 'MY_ACCOUNT_MENU.FINANCIAL',
	},
];
